export const Exceptions = {
    NoSuchUserException: 'com.actimind.actitime.administration.NoSuchUserException',
    NoSuchCopyUserException: 'com.actimind.actitime.administration.SelectedUserDeletedException',
    NoRightsToManageAccountSettings: 'com.actimind.actitime.administration.NoSuchUserException',
    UserHasAccessToAllScopeException: 'com.actimind.actitime.services.UserHasAccessToAllScopeException'
}



// WEBPACK FOOTER //
// ./web/js/panels/user/editTeamAssignmentsPanel/constants.js